/**
 * Constants for StanFilters components
 * Centralizes magic strings and reduces duplication
 */

import { StanFilterOperatorCode } from './types';

// Default reduce key for dropdown options
export const DEFAULT_REDUCE_KEY = 'label';

// Filter field IDs
export const FILTER_FIELD_IDS = {
    ORDERS_PRODUCT_ID: 'orders-product-id',
} as const;

// Filter operators
export const FILTER_OPERATORS = {
    EQUALS: 'eq',
    CONTAINS: 'li',
    GREATER_THAN: 'gt',
    LESS_THAN: 'lt',
    GREATER_THAN_OR_EQUAL: 'gte',
    LESS_THAN_OR_EQUAL: 'lte',
    BETWEEN: 'bt',
} as const satisfies Record<string, StanFilterOperatorCode>;

// Default operator values for different filter types
export const DEFAULT_OPERATORS = {
    TEXT: FILTER_OPERATORS.CONTAINS,
    NUMBER: FILTER_OPERATORS.GREATER_THAN_OR_EQUAL,
    SELECT: FILTER_OPERATORS.CONTAINS,
} as const;
